import fetch from 'isomorphic-fetch';
import Constants from '../definitions/constants';
import JavascriptUtilsTooling from '../tooling/javascriptUtilsTooling';

const ReducersTooling = {
  initialStates: {
    getFetchTypeInitialState: () => {
      return {
        data: {},
        firstLoading: true,
        loading: false,
        status: null,
        errors: {}
      };
    },
    getFetchTypeInitialStateDelete: () => {
      return {
        id: null,
        loading: false,
        status: null,
        errors: {}
      };
    },
    getFetchTypeInitialStateAssign: () => {
      return {
        id: null,
        assignId: null,
        add: null,
        firstLoading: true,
        loading: false,
        status: null,
        errors: {}
      };
    },
    getFetchTypeInitialStateList: () => {
      return {
        firstLoading: true,
        loading: false,
        errors: {},
        status: null,
        data: null,
        page: 1,
        totalPages: null,
        totalRecords: null,
        paginationStatus: null,
        additionalData: null,
        pageSize: Constants.interface.entityListPageSize,
        orderBy: null,
        orderByDirection: null,
      };
    },
    getFetchTypeInitialStateListAssign: () => {
      return {
        assignId: null,
        assignName: null,
        firstLoading: true,
        loading: false,
        errors: {},
        status: null,
        data: null,
        page: 1,
        totalPages: null,
        totalRecords: null,
        paginationStatus: null,
        additionalData: null,
        pageSize: Constants.interface.assignListPageSize,
        orderBy: null,
        orderByDirection: null,
      };
    }
  },
  generalReducers: {
    getFetchTypeNewStateInit: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] = {
        ...initialState[path],
        firstLoading: state[path].firstLoading,
        loading: true
      };
      return newState;
    },
    getFetchTypeNewStateSuccess: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...state[path],
        firstLoading: false,
        errors: (action.payload.status == 200) ? null: action.payload.data,
        loading: false,
        status: action.payload.status,
        data: action.payload.data
      };
      return newState;
    },
    getFetchTypeNewStateFailure: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        firstLoading: false,
        errors: action.error,
        status: 500
      };
      return newState;
    },
    getFetchTypeNewStateReset: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        firstLoading: state[path].firstLoading
      };
      return newState;
    }
  },
  entityTableReducers: {
    getFetchTypeNewStateInitList: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] = {
        ...initialState[path],
        firstLoading: state[path].firstLoading,
        page: action.params.page ? action.params.page : 1,
        orderBy: action.params.order_fields && action.params.order_fields[0] ? 
          action.params.order_fields[0] : null,
        orderByDirection: action.params.order_directions && action.params.order_directions[0] ? 
          action.params.order_directions[0] : null,
        loading: true,
        totalPages: action.paging ? state[path].totalPages : initialState[path].totalPages,
        totalRecords: action.paging ? state[path].totalRecords : initialState[path].totalRecords,
        paginationStatus: action.paging ? state[path].paginationStatus : initialState[path].paginationStatus,
        additionalData: action.paging ? state[path].additionalData : initialState[path].additionalData,
      };
      return newState;
    },
    getFetchTypeNewStateSuccessList: (initialState, state, action, path) => {
      var newData = action.payload.data && action.payload.data.collection ? 
        action.payload.data.collection : null;  
      let newState = { ...state };
      newState[path] =  {
        ...state[path],
        firstLoading: false,
        errors: (action.payload.status == 200) ? null: action.payload.data,
        loading: false,
        status: action.payload.status,
        data: newData,
        totalPages: action.payload.data && action.payload.data.paginationStatus ? 
          action.payload.data.paginationStatus.total_pages : null,
        totalRecords: action.payload.data && action.payload.data.paginationStatus ? 
          action.payload.data.paginationStatus.total_records : null,
        paginationStatus: action.payload.data && action.payload.data.paginationStatus ? 
          action.payload.data.paginationStatus : null,
        additionalData: action.payload.data && action.payload.data.additionalData ? 
          action.payload.data.additionalData : null
      };
      return newState;
    },
    getFetchTypeNewStateFailureList: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        firstLoading: false,
        errors: action.error,
        status: 500
      };
      return newState;
    },
    getFetchTypeNewStateInitSave: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] = {
        ...initialState[path],
        data: state[path].data,
        loading: true
      };
      return newState;
    },
    getFetchTypeNewStateSuccessSave: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...state[path],
        loading: false,
        status: action.payload.status,
        errors: action.payload.status!=200 ? action.payload.data : {}
      };
      return newState;
    },
    getFetchTypeNewStateFailureSave: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        status: 500,
        data: state[path].data,
        errors: action.error
      };
      return newState;
    },
    getFetchTypeNewStateSetDataByKeySave: (initialState, state, action, path) => {
      var data = JavascriptUtilsTooling.deepCopy(state[path].data);  
      JavascriptUtilsTooling.setObjectStringPathKeyValue(data, action.key, action.value);
      let newState = { ...state };
      newState[path] =  {
        ...state[path],
        data: data
      };
      return newState;
    },
    getFetchTypeNewStateResetSave: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        data: action.data
      };
      return newState;
    },
    getFetchTypeNewStatePrepareDelete: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        id: action.id
      };
      return newState;
    },
    getFetchTypeNewStateInitDelete: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] = {
        ...initialState[path],
        id: state[path].id,
        loading: true
      };
      return newState;
    },
    getFetchTypeNewStateSuccessDelete: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        id: state[path].id,
        status: action.payload.status,
        errors: action.payload.data
      };
      return newState;
    },
    getFetchTypeNewStateFailureDelete: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        id: state[path].id,
        status: 500,
        errors: action.error
      };
      return newState;
    }
  },
  assignTableReducers: {
    getFetchTypeNewStateInitListAssign: (initialState, state, action, path) => {
      let newState = ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, path);
      newState[path].assignId = action.params.id;
      newState[path].assignName = action.params.name;
      return newState;
    },
    getFetchTypeNewStateInitSaveAssign: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        loading: true,
        id: action.params.id,
        assignId: action.params.related_entity_id,
        add: action.params.add
      };
      return newState;
    },
    getFetchTypeNewStateSuccessSaveAssign: (initialState, state, action, path, listPath, parentListPath, parentInfoField = null) => {
      let newState = { ...state };
      if(action.payload.status == 200 && newState[listPath].data && newState[parentListPath].data) {
        let itemName = "";
        for(let i=0; i<newState[listPath].data.length; i++) {
          let item = newState[listPath].data[i];
          if(item.id == state[path].assignId) {
            item.related_entity_id = state[path].add ? state[path].id : null; 
            itemName = item.name;
          }
        }
        if(parentInfoField!=null && itemName) {
          for(let i=0; i<newState[parentListPath].data.length; i++) {
            let item = newState[parentListPath].data[i];
            if(item.id == action.payload.data.id && (parentInfoField in item) && item[parentInfoField]!=null) {
              let array_temp = item[parentInfoField].split(", ");
              if(state[path].add) {
                array_temp.push(itemName)
              }
              else {
                array_temp = array_temp.filter(string => string != itemName);
              }
              newState[parentListPath].data[i][parentInfoField] = 
                array_temp.filter(string => string != "").sort().join(", ");
            }
          }
        }
      }
      if(action.payload.status == 200 && newState[listPath].paginationStatus && 
         "total_associated_records" in newState[listPath].paginationStatus) {
        newState[listPath].paginationStatus.total_associated_records += state[path].add ? 1 : -1;
      }
      if(action.payload.status == 200 && newState[listPath].paginationStatus && 
         "total_direct_associated_records" in newState[listPath].paginationStatus) {
        newState[listPath].paginationStatus.total_direct_associated_records += state[path].add ? 1 : -1;
      }
      newState[path] =  {
        ...state[path],
        loading: false,
        status: action.payload.status,
        errors: action.payload.data
      };
      return newState;
    },
    getFetchTypeNewStateFailureSaveAssign: (initialState, state, action, path) => {
      let newState = { ...state };
      newState[path] =  {
        ...initialState[path],
        errors: action.error,
        status: 500
      };
      return newState;
    }
  },
};

export default ReducersTooling;


// WEBPACK FOOTER //
// ./source/tooling/reducersTooling.js